import '@/components/lost-found';

export default {
    name: 'lost-found',
    props: ['propertyIds'],
    data() {
        return {
            view: 'open',
            auth: JSON.parse(window.localStorage.getItem('authenticated'))
        };
    }
};
